import { Navigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import { hasEnpsModule } from 'modules/engagement/lib/hasEnpsModule'
import type EnpsForm from 'modules/enps/store/models/Form'

import Upsell from './Upsell'

const IndexPage = () => {
  const { navigation } = useNavigation()
  const { form } = useOutletContext<{ form: EnpsForm }>()
  const canEdit = form.policy.can('editEnpsForm')
  const { moduleAvailabilities } = useEngagementContext()
  const enpsEnabled = hasEnpsModule(moduleAvailabilities)
  if (!enpsEnabled) {
    return <Upsell />
  }
  return (
    <Navigate
      to={
        canEdit
          ? navigation.engagement.enps.analytics.fullPath()
          : navigation.engagement.enps.answers.fullPath()
      }
    />
  )
}

export default IndexPage
